import messagesEn from '../locales/account/en.json'
import messagesFr from '../locales/account/fr.json'

export default {
    en: messagesEn,
    fr: messagesFr
}
